'use client';

import { motion } from 'framer-motion';

import { useInView } from '@/slw/shared/lib/animation';

const values = [
  {
    icon: '/images/icon/burning-passion.svg',
    title: 'Passion',
    desc: `We share our users’ enthusiasm for classic cars and are committed to celebrating and 
      preserving automotive history. You won't find any 2003 minivans here.`,
  },
  {
    icon: '/images/icon/lucide-heart.svg',
    title: 'Integrity',
    desc: `We believe in honest and open communication, 
      ensuring that all transactions are conducted with utmost integrity and transparency.`,
  },
  {
    icon: '/images/icon/famicons-diamond.svg',
    title: 'Quality',
    desc: `We strive to offer a platform that reflects high standards of quality, 
      from the cars we curate to the customer service we provide.`,
  },
  {
    icon: '/images/icon/fluent-people.svg',
    title: 'Community',
    desc: `We aim to build a community of like-minded individuals who appreciate classic cars and
       support one another in the pursuit of their passion.`,
  },
];

export function ValuesSectionContent() {
  const [ref, inView] = useInView(0.18);

  return (
    <section ref={ref} className='w-full py-10 md:py-24'>
      <h2 className='text-center text-2xl md:text-[2.5rem] font-bold mb-8 md:mb-16 text-primary'>
        The Values That We Bring
      </h2>
      <motion.div
        className='grid bg-[#F8F8F7] border rounded-2xl  border-primary border-dashed
 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 md:gap-8 gap-2 md:p-8'
        initial='hidden'
        animate={inView ? 'visible' : 'hidden'}
        variants={{
          visible: { transition: { staggerChildren: 0.18 } },
          hidden: {},
        }}
      >
        {values.map((v) => (
          <div
            key={v.title}
            className='py-8 px-4 gap-4 rounded-2xl bg-white flex flex-col 
            items-center text-center group transition-all'
          >
            <img src={v.icon} alt={v.title} className='w-12 h-12' />
            <h3 className='md:text-2xl text-lg font-bold'>{v.title}</h3>
            <p className='text-sm'>{v.desc}</p>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
